/**
 * Dev-mode backdoor — bypasses Google OAuth and uses an in-memory
 * SheetsClient stub so Playwright (and future automated tests) can drive
 * the app end-to-end without a real Google session.
 *
 * Activation:
 *   - URL query: `?devmode=mochi-dev-2026` (one-time, persists via localStorage)
 *   - URL path:  `/?devmode=mochi-dev-2026#/home`
 *   - Disable:   `?devmode=off` clears the flag
 *
 * Token: a fixed 64-char hex string is set so the existing token-injection
 * guard in `client.ts:safeAuthHeader` accepts it. Memory client ignores it.
 *
 * NOT a security risk: no real Google data is touched. The memory client
 * is in-process; nothing ever leaves the browser.
 */

const TOKEN = 'mochi-dev-2026';
const STORAGE_KEY = 'mochia.devmode';
const EMAIL = 'devmode@mochia.test';

export const DEV_FAKE_TOKEN = 'a'.repeat(64);
export const DEV_FAKE_EMAIL = EMAIL;
export const DEV_SPREADSHEET_ID = 'dev-mochi-data-spreadsheet';

export function isDevMode(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams.get('devmode');
    if (q === TOKEN) {
      window.localStorage.setItem(STORAGE_KEY, 'on');
      // Strip the query so reloads don't re-set the flag.
      url.searchParams.delete('devmode');
      window.history.replaceState({}, '', url.toString());
      return true;
    }
    if (q === 'off') {
      window.localStorage.removeItem(STORAGE_KEY);
      url.searchParams.delete('devmode');
      window.history.replaceState({}, '', url.toString());
      return false;
    }
    return window.localStorage.getItem(STORAGE_KEY) === 'on';
  } catch {
    return false;
  }
}
